<template>
  <div class="home">
    <div
      class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">
          Course Certificates
        </div>
        <a
          href="https://res.cloudinary.com/lms-edc/image/upload/v1597078425/xh6hgtg1jahq4oklkg4p.pdf"
          >Download Template</a
        >
      </div>
    </div>

    <div class="flex flex-wrap">
      <div
        v-for="(certificate, i) in filteredRecords"
        :key="i"
        class="w-full md:w-1/3 flex"
      >
        <card :certificate="certificate" class=" m-4" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
export default {
  data() {
    return {
      quickSearch: "",
      list: [],
    };
  },
  computed: {
    filteredRecords() {
      let data = this.list.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.quickSearch.toLowerCase()) > -1
          );
        });
      });

      return data;
    },
  },
  components: {
    card: () => import("@/components/tenant/certificate-card"),
    lbutton: () => import("@/components/general/button"),
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantAllCertificates", "tenantDeleteCertificate"]),
    async loadData() {
      this.updateLoader(true);
      let res = await this.tenantAllCertificates();
      this.list = res.data.data.certificates;
      this.updateLoader(false);
    },
    async deleteData(e) {
      if (confirm("Are you sure you want to delete this Instructor?")) {
        let res = await this.tenantDeleteInstructor({
          id: e,
        });
        this.loadData();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Instructor deleted successfully",
        });
        //console.log(e);
      }
    },
  },
  async mounted() {
    this.$Bus.$on("delete-certificate", async (data) => {
      await this.tenantDeleteCertificate({
        id: data,
      });
      this.$Bus.$emit("notify", {
        type: "success",
        message: "Certificate deleted successfully",
      });
      this.loadData();
    });
    this.loadData();
  },
};
</script>
